/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { visit } from 'unist-util-visit';
/**
 * Represents the default options of the plugin.
 */
const defaultOptions = {
    regex: /{json-ref:([a-z0-9\\-]+)}/,
};
/**
 * Extract "json-ref" value in the given text
 */
function extractJsonRefId(text, regex) {
    const match = text.match(regex);
    if (match) {
        return match[1];
    }
    return undefined;
}
/**
 * Represents a plugin for rehype, able to manage the multipart json content.
 */
function plugin(options = defaultOptions) {
    return (tree) => {
        visit(tree, 'element', node => {
            // detect that the text content match the following format.
            // {json-ref:<string>}
            if (node.tagName === 'p' && node.properties) {
                // guard.
                if (node.children.length !== 1) {
                    return;
                }
                // get child node.
                const childNode = node.children[0];
                // guard.
                if (childNode.type !== 'text') {
                    return;
                }
                // extract json ref id.
                const jsonRefId = extractJsonRefId(childNode.value, options.regex);
                // no json ref id.
                if (!jsonRefId) {
                    return;
                }
                // mutate node.
                node.tagName = 'pwc-message-part';
                node.properties = {
                    'ref-id': jsonRefId,
                };
                node.children = [];
            }
        });
    };
}
export default plugin;
//# sourceMappingURL=rehype-pros-multipart-json.js.map